import { Button, Form, Input, Select, Upload, message } from 'antd'
import React, { Component } from 'react'
import { ListTicketTypes, SendTicket } from '../../network/profile.network'
import localization from '../../Localization/Localization.json'
import { connect } from 'react-redux'

class AddTicket extends Component {

    state = {
        btnLoading : false,
        listTicketTypes : [],
        fileList : []
    }

    componentDidMount() {
        ListTicketTypes(res => {
            console.log(res)
            if(res.data.code === 200){ 
                this.setState({ listTicketTypes : res.data.data.supportTypes })
            }
        }, error => {
            console.log(error) 
        })
    }

    onFinish = (values) => {
        const {currentUser} = this.props; 
        if(!currentUser) return false;
        this.setState({btnLoading : true})
        let body = new FormData();
        console.log(values)
        body.append("name", currentUser.first_name || "");
        body.append("email", currentUser.email || "");
        body.append("phone", currentUser.phone || "");
        body.append("subject", values.title);
        body.append("message", values.Additionalnote);
        body.append("support_type_id", values.issuetype);
        body.append("attachments[0]", this.state.fileList.length === 1 ? this.state.fileList[0].originFileObj : null);
        SendTicket(
          body,
          (res) => {
            this.setState({btnLoading : false})
            console.log(res) 
            if(res.data.code === 200){  
                message.success(res.data.message);
                setTimeout(() => {
                    this.props.showTicketsDone();
                }, 1000)
                
            }
          },
          (error) => {
            console.log(error);  
            this.setState({btnLoading : false})
          }
        );
      };

      normFile = (e) => {
        //   if(this.state.fileList.length === 1){
        //       return false; 
        //   }
            console.log('Upload event:', e); 
            console.log(e.file.originFileObj)
            this.setState({fileList : e.fileList})
        if (Array.isArray(e)) {
          return e;
        } 
      
        return e && e.fileList;
      };
    
    render() {
        const {currentLang} = this.props; 
        const {btnLoading, listTicketTypes} = this.state;
        return (
            <div className="add-issue-wrapper">
                <div className="ticket-list-header">
                    <h5>{localization.CreatenewIssue[currentLang]}</h5>
                    <Button className="primary-light" size="large" type="primary" onClick={() => this.props.showTicketsList()}>{localization.Cancel[currentLang]}</Button>
                </div>
                <div className="add-issue-form">
                <Form
              name="basic"
              onFinish={this.onFinish}
            >
                <Form.Item
                        name="issuetype"
                        label={localization.Selectissuetype[currentLang]}
                        rules={[
                        {
                            required: true,
                            message: `${localization.pleaseselect[currentLang]} ${localization.issuetype[currentLang]}`
                        },
                        ]}
                        className="input-select-holder"
                    >
                        <Select
                        placeholder={localization.issuetype[currentLang]}
                        >
                            {listTicketTypes.map(Type => <Select.Option key={Type.id} value={Type.id}>{Type.name}</Select.Option>)}
                        </Select>
                    </Form.Item>
              <Form.Item
                label={localization.Title[currentLang]}
                name="title"
                rules={[
                  { required: true, message: `${localization.Pleaseinput[currentLang]} ${localization.Title[currentLang]}` },
                ]}
                className="input-holder"
              >
                <Input placeholder={localization.Title[currentLang]} /> 
              </Form.Item> 
              <Form.Item
                label={localization.Additionalnote[currentLang]}
                name="Additionalnote"
                rules={[
                  { required: true, message: `${localization.Pleaseinput[currentLang]} ${localization.Additionalnote[currentLang]}` },
                ]}
                className="input-holder"
              >
                <Input placeholder={localization.Additionalnote[currentLang]} />
              </Form.Item>
              <Form.Item className="upload-wrapper">
                    <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={this.normFile} noStyle>
                    <Upload.Dragger maxCount={1} name="files">
                        <p className="ant-upload-text">{localization.uploadattachments[currentLang]}</p> 
                        <p className="ant-upload-hint">(PNG,JPG and PDF)</p>  
                    </Upload.Dragger>
                    </Form.Item>
                </Form.Item>
              <Form.Item >
                <Button style={{marginTop : 16}} size="large" type="primary" htmlType="submit" loading={btnLoading}>
                {localization.Send[currentLang]} 
                </Button>
              </Form.Item>
            </Form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    currentLang : state.user.currentLang,
    currentUser : state.user.currentUser,
  }) 

export default connect(mapStateToProps)(AddTicket);

